<div class="min-h-screen w-full mx-auto px-4 flex flex-col" *ngIf="config">
  <div class="flex flex-row justify-between">
    <img src="https://uploads.snapmatic.me/32408cfa-22b9-4637-9a9b-418e6ec0bf32/assets/581c489a-4b4b-4537-a638-44176c787d88.svg" alt="Logo" class="w-64 py-6 px-3">
    <content-block [slug]="'gallery-header'" id="gallery-header"></content-block>
  </div>

  <div class="grid grid-cols-6 grid-flow-row gap-4">
    <ng-container *ngFor="let job of jobs">
      <div class="relative w-full" *ngIf="job && job.status == 'completed' && hasAtLeastOneOutputAsset(job)">
        <image-slider [images]="filter(job.assets)" [autoPlaySpeed]="job.interval || 3000" [aspectClass]="'1080/1608'"></image-slider>
      </div>
    </ng-container>
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper"></content-block>

</div>

